import React, { useEffect, useState } from "react";
import {
  Fade,
  IconButton,
  Typography,
  makeStyles
} from "@material-ui/core";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";

import i1 from "../images/i1.png";
import i2 from "../images/i2.png";
import i3 from "../images/i3.png";

const useStyles = makeStyles((theme) => ({
  // Contenedor principal sin altura fija, para que la imagen lo defina
  carouselContainer: {
    position: "relative",
    width: "100%",
    margin: 0,
  },
  slide: {
    width: "100%",
    position: "relative",
  },
  // Imagen responsive: ancho al 100%, alto automático, se recorta ("cover")
  image: {
    width: "100%",
    height: "auto",
    objectFit: "cover",
    display: "block",
  },
  // Capa semitransparente sobre la imagen
  overlay: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.4)",
    color: "#fff",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    padding: theme.spacing(2),
  },
  // Texto en el centro del carrusel
  textOverlay: {
    // Tamaño por defecto (pantallas grandes)
    fontSize: "1.6rem",
    fontFamily: "Helvetica, Arial, sans-serif",
    lineHeight: 1.6,
    color: "rgba(255, 255, 255, 0.9)", // Semitransparente (ajusta a tu gusto)
    maxWidth: "60%",                  // Limita el ancho del texto
    margin: "0 auto",

    // Breakpoints para hacerlo más pequeño en pantallas medianas y chicas
    [theme.breakpoints.down("md")]: {
      fontSize: "1.3rem", // Ajusta en pantallas medianas (md ~960px)
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "1rem",   // Ajusta en pantallas pequeñas (sm ~600px)
    },
  },
  arrow: {
    position: "absolute",
    top: "50%",
    transform: "translateY(-50%)",
    color: "#fff",
    backgroundColor: "rgba(0,0,0,0.3)",
    "&:hover": {
      backgroundColor: "rgba(0,0,0,0.5)",
    },
  },
  arrowLeft: {
    left: theme.spacing(2),
  },
  arrowRight: {
    right: theme.spacing(2),
  },
  indicators: {
    position: "absolute",
    bottom: theme.spacing(2),
    left: "50%",
    transform: "translateX(-50%)",
    display: "flex",
    gap: theme.spacing(1),
  },
  indicator: {
    width: 12,
    height: 12,
    borderRadius: "50%",
    backgroundColor: "rgba(255,255,255,0.5)",
    cursor: "pointer",
    "&.active": {
      backgroundColor: "#fff",
    },
  },
}));

// Texto que aparecerá en el centro del carrusel
const textoQuienesSomos = `
En Q2, somos especialistas en brindar soluciones tecnológicas innovadoras para la gestión de
acreditaciones en eventos. Nuestro enfoque combina eficiencia, seguridad y personalización,
permitiendo a organizadores y asistentes disfrutar de una experiencia fluida desde el registro
hasta el cierre del evento. Con un sistema desarrollado completamente por nuestro equipo,
garantizamos una plataforma moderna, adaptable y de alto rendimiento, diseñada para satisfacer
las necesidades de cada cliente y maximizar el éxito de sus eventos.
`;

const Carousel = () => {
  const classes = useStyles();

  // Imágenes del carrusel
  const slides = [
    { src: i1, alt: "site 1" },
    { src: i2, alt: "site 2" },
    { src: i3, alt: "site 3", style: { filter: "grayscale(100%)" } },
  ];

  const [activeStep, setActiveStep] = useState(0);

  // Cambio automático cada 3 segundos
  useEffect(() => {
    const timer = setInterval(() => {
      setActiveStep((prev) => (prev + 1) % slides.length);
    }, 3000);
    return () => clearInterval(timer);
  }, [slides.length]);

  const handleNext = () => {
    setActiveStep((prev) => (prev + 1) % slides.length);
  };

  const handleBack = () => {
    setActiveStep((prev) => (prev - 1 + slides.length) % slides.length);
  };

  const handleIndicatorClick = (index) => {
    setActiveStep(index);
  };

  return (
    <div className={classes.carouselContainer}>
      {/* Transición Fade */}
      <Fade in={true} key={activeStep} timeout={1000}>
        <div className={classes.slide}>
          <img
            src={slides[activeStep].src}
            alt={slides[activeStep].alt}
            className={classes.image}
          />
        </div>
      </Fade>

      {/* Capa semitransparente con texto */}
      <div className={classes.overlay}>
        <Typography variant="body1" className={classes.textOverlay}>
          {/* {textoQuienesSomos} */}
        </Typography>
      </div>

      {/* Flechas de navegación */}
      <IconButton
        className={`${classes.arrow} ${classes.arrowLeft}`}
        onClick={handleBack}
      >
        <ArrowBackIosIcon />
      </IconButton>
      <IconButton
        className={`${classes.arrow} ${classes.arrowRight}`}
        onClick={handleNext}
      >
        <ArrowForwardIosIcon />
      </IconButton>

      {/* Indicadores */}
      <div className={classes.indicators}>
        {slides.map((_, index) => (
          <div
            key={index}
            className={`${classes.indicator} ${
              index === activeStep ? "active" : ""
            }`}
            onClick={() => handleIndicatorClick(index)}
          />
        ))}
      </div>
    </div>
  );
};

export default Carousel;
